import { useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "../../../../../AppContext";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { IFamilyWizardFormModel } from "../models/familyWizardFormModel";
import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { useFamilyWizardForm } from "./useFamilyWizardForm";
import { PageMode } from "../../../../../common/types";
import { SubmitHandler } from "react-hook-form";
import { routePaths } from "../../../../../common/infrastructure/routes/routePaths";
import { IFamilyWizardViewModel } from "../models/familyWizardViewModel";
import { useMemo } from "react";
import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

export const useFamilyWizardPage = (pageMode: PageMode) => {
  const { selectedStudioId } = useAppContext();
  const navigate = useNavigate();

  const { mutate } = useApiMutation();

  const { id } = useParams();

  const { data: family } = useApiQuery<IFamilyWizardViewModel>({
    queryKey: [endpointsMetadata.family.wizardGetFamily, id],
    endpoint: `${endpointsMetadata.family.wizardGetFamily}?familyId=${id}`,
    enabled: id !== undefined,
    globalIsLoading: true,
  });

  const { data: users } = useApiQuery<ISelectFieldModel[]>({
    queryKey: [endpointsMetadata.family.getAllAvailableUsers, id],
    endpoint: `${endpointsMetadata.family.getAllAvailableUsers}?familyId=${
      id ?? 0
    }`,
  });

  const form = useFamilyWizardForm(selectedStudioId, id, family);

  const membersWatch = form.watch("members");

  const selectedUsers = useMemo(() => {
    return users?.filter((u) => membersWatch?.includes(u.id)) ?? [];
  }, [membersWatch, users]);

  const pageTitle = `${
    pageMode === "add" ? "Добавяне" : "Редактиране"
  } на семейство`;

  const actionButtonLabel = pageMode === "add" ? "Добавяне" : "Запазване";

  const handleSubmit: SubmitHandler<IFamilyWizardFormModel> = async (data) => {
    mutate(
      {
        endpoint: endpointsMetadata.family.wizard,
        method: "post",
        invalidateKeys: [[endpointsMetadata.family.getAll]],
        globalIsLoading: true,
        ...data,
      },
      {
        onSuccess: () => {
          navigate(routePaths.families);
        },
      }
    );
  };

  return {
    form,
    pageTitle,
    // isLoading,
    selectedUsers,
    users,
    actionButtonLabel,
    handleSubmit,
  };
};
